import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getClassByStatusWithCondition = (
  Condition,
  Status,
  pageNum,
  pageSize
) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_CLASS_BY_STATUS_WITH_CONDITION(
      Condition,
      Status,
      pageNum,
      pageSize
    )
  );
};

export default getClassByStatusWithCondition;
